<p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="3" animationDuration=".5s" />
